import { deleteRequest, get, post, publicPost, put } from "../../helpers/apihelpers";

export const CreateStudentSubjectService=async(data)=>{
    try {
        const result = await post(`api/admin/section_subject/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateStudentSubjectService=async(data,id)=>{
    try {
        const result = await put(`api/admin/section_subject/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetStudentSubjectService=async()=>{
    try {
        const result = await get(`api/admin/section_subject/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteStudentSubjectService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/section_subject/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

